import moment from 'moment';
import React, { useRef } from 'react'
import { Alert, Card, CardBody } from 'reactstrap'
import XLSX from "xlsx";


const ComponentCargaMasiva = ({ datosPlantilla, setDatos, setColumnas, plantillaConError,cerrado=false, setPlantillaConError }) => {


    const fileInputRef = useRef(null);
    /**
     * Acción al escoger un nuevo archivo
     * @param {*} e 
     */
    const handleChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) handleFile(files[0]);
        fileInputRef.current.value = null;
    }

    /**
     * Procesamiento del archivo excel
     * @param {*} file archivo seleccionado
     */
    const handleFile = (file /*:File*/) => {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = e => {
            console.log(' e.target.result', e.target.result)
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {
                type: rABS ? "binary" : "array", cellDates: true,
                cellNF: false,
                cellText: true,

            });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            console.log('data2', rABS, wb);
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 2 });
            /* Update state */

            var aux = []


            data.forEach(persona => {

                const auxObj = persona
                const fecha = moment(persona['FECHA DE NACIMIENTO'], 'DD/MM/YYYY')

                const fechaFormat = fecha.isValid() ? fecha.format("DD/MM/YYYY") : null
                console.log('cargaVidas',fecha, fechaFormat)
                auxObj.fechaNacimiento = fechaFormat ? fechaFormat : moment().format("DD/MM/YYYY")
                auxObj['FECHA DE NACIMIENTO'] = fechaFormat ? fechaFormat : moment().format("DD/MM/YYYY")
                aux.push(auxObj)
            });





            const columnsArray = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
            const valid = JSON.stringify(datosPlantilla.columnas) === JSON.stringify(columnsArray)

            if (valid) {

                let hash = {};
                aux = aux.filter(o => hash[o.IDENTIFICACION] ? false : hash[o.IDENTIFICACION] = true);
                setDatos(limpiarDatos(aux))
                setColumnas(columnsArray)
            } else {
                setPlantillaConError(true)
            }





            console.log('cooososos', datosPlantilla.columnas, columnsArray, valid)
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
    }

    function reemplazarTildes(cadena) {
        const mapaTildes = {
            '&aacute;': 'á',
            '&eacute;': 'é',
            '&iacute;': 'í',
            '&oacute;': 'ó',
            '&uacute;': 'ú',
            '&Aacute;': 'Á',
            '&Eacute;': 'É',
            '&Iacute;': 'Í',
            '&Oacute;': 'Ó',
            '&Uacute;': 'Ú',
            '&ntilde;': 'ñ',
            '&Ntilde;': 'Ñ'
        };

        return cadena.replace(/&[a-zA-Z]+;/g, match => mapaTildes[match] || match);
    }

    function limpiarDatos(arr) {
        return arr.map(obj => {
            // Crear el objeto base con los campos necesarios
            console.log('verInfoImportante',obj )
            let resultado = {
                ...obj,
                IDENTIFICACION: obj.IDENTIFICACION.toString().replace(/\D/g, ''), // Solo números
                "NOMBRE Y APELLIDO": reemplazarTildes(obj["NOMBRE Y APELLIDO"].replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1\s]/g, '')), // Permite letras, espacios, tildes y ñ
                "FECHA DE NACIMIENTO": obj["fechaNacimiento"].replace(/[^0-9\/]/g, ''), // Solo números y /
                "fechaNacimiento": obj["fechaNacimiento"].replace(/[^0-9\/]/g, '') // Solo números y /        
            };
            
            // Si incluirCargo es true, agregar el campo CARGO
            if (cerrado) {
                resultado.CARGO = reemplazarTildes(obj["CARGO"].replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1\s]/g, '')); // Permite letras, espacios, tildes y ñ
            }
    
            return resultado;
        });
    }
    





    return (
        <Card>
            <CardBody>
                <h4>Creación Masiva</h4>
                <p>Información del asegurado</p>

                <Card style={{ backgroundColor: '#dcecd4' }}>
                    <CardBody>
                        <p>{'Paso 1 Descargar plantilla   '}


                            <a
                                className='btn btn-detail-white'
                                href={datosPlantilla.urlPlantilla}
                                style={{ backgroundColor: '#4ca2d9', color: 'white' }}
                                target='_blank'
                                rel='noopener noreferrer'>
                                <i
                                    className='fa fa-cloud-download'
                                    aria-hidden='true'
                                />{" "}
                                DESCARGAR PLANTILLA
                            </a>
                        </p>

                    </CardBody>
                </Card>

                <Card style={{ backgroundColor: '#dcecd4' }}>
                    <CardBody>
                        <p>{'Paso 2 Cargar plantilla   '}


                            <label htmlFor="formId">

                                <input

                                    type="file"
                                    ref={fileInputRef}
                                    onChange={(e) => handleChange(e)}
                                    id="formId"
                                    accept=".xls"
                                    hidden
                                    target='_blank'
                                    rel='noopener noreferrer'

                                >

                                </input>

                                <div
                                    className='btn btn-detail-white'
                                    style={{ backgroundColor: '#4ca2d9', color: 'white' }}
                                >

                                    <div>
                                        <i
                                            className='fa fa-cloud-upload'
                                            aria-hidden='true'
                                        />{" "}
                                        CARGAR PLANTILLA
                                    </div>

                                </div>

                            </label>






                        </p>





                    </CardBody>
                </Card>

                <Alert
                    color="danger"
                    isOpen={(plantillaConError)}
                    toggle={() => setPlantillaConError(false)}
                >
                    <center>
                        <p>
                            {'Plantilla con formato incorrecto'}
                        </p>
                    </center>
                </Alert>





            </CardBody>
        </Card>
    )

}

export default ComponentCargaMasiva